var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX6X12BonusesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.25,
    height: 36,
    viewBox: "0 0 38.25 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-pie",
    "data-name": "Icon awesome-chart-pie",
    d: "M37.11,20.25H20.426L31.537,31.361a1.128,1.128,0,0,0,1.56.048,16.84,16.84,0,0,0,5.142-9.9A1.127,1.127,0,0,0,37.11,20.25ZM36,15.694A16.915,16.915,0,0,0,20.306,0a1.131,1.131,0,0,0-1.181,1.139V16.875H34.859A1.131,1.131,0,0,0,36,15.694ZM15.75,20.25V3.566A1.127,1.127,0,0,0,14.5,2.436,16.863,16.863,0,0,0,.01,19.714,17.083,17.083,0,0,0,17.088,36a16.744,16.744,0,0,0,9.51-3.1,1.117,1.117,0,0,0,.11-1.693Z",
    transform: "translate(0 0)",
    fill: "#3d3d3d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX6X12BonusesIcon);
export default __webpack_public_path__ + "static/media/x6x12-bonuses-icon.dc45ad2e58f9574e618fcb0b3ca7b8c1.svg";
export { ForwardRef as ReactComponent };